@if (!_loadOption || _loadOption == "HAENGIGE") {
  <h3>{{ "HängigeAufträge" | translate }}</h3>
}
@if (_loadOption && _loadOption == "ALLE") {
  <h3>{{ "Auftraege" | translate }}</h3>
}

<cap-list-loader [hasRight]="hasRight" [listLoader]="haengigeLoader">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'HängigeAufträge' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th class="noselect" style="cursor: pointer; width: 20%">
      <cap-column-header [columnName]="'Auftrags-Nr'" [sortModel]="tableSortModel.columns.get('auftragsNr')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer; width: 25%">
      <cap-column-header [columnName]="'Status'" [sortModel]="tableSortModel.columns.get('status')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer; width: 15%">
      <cap-column-header [columnName]="'Erstelldatum'" [sortModel]="tableSortModel.columns.get('erstellDatum')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer; width: 40%">
      <cap-column-header [columnName]="'Beschreibung'" [sortModel]="tableSortModel.columns.get('beschreibung')"></cap-column-header>
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (auftrag of haengigeLoader?.items; track auftrag) {
    <tr>
      <td>{{ auftrag.auftragNummer }}</td>
      <td>{{ auftrag.status | translate }}</td>
      <td>{{ auftrag.erstellDatum | datum }}</td>
      <td>
        @if (auftrag.mBeschreibung.access !== "NONE") {
          <span>{{ auftrag.beschreibung }}</span>
        }
        @if (auftrag.mBeschreibung.access === "NONE") {
          <span>{{"gemaessGrundbuch" | translate}}</span>
        }
      </td>
    </tr>
  }
</ng-template>
